
import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';

import { map } from 'rxjs/operators';
import { Actions } from '../../actions';
import { CleanRelease } from '@webapp/store/release/action-creators';
import { CLEAN_RELEASE } from '../../release/actions';
import { ClearAssets } from '../action-creators';


export const clearAssetsEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, CleanRelease>(CLEAN_RELEASE),
    map(() => new ClearAssets())
  );